module.exports = __webpack_public_path__ + "static/media/offline.e1ce1ba0.svg";